import { Shield, Users, Building2, HardHat } from "lucide-react";
import Logo from '../assets/logo2.jpg';

export default function AdminLanding() {
  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900 text-white">
      {/* Background decorative elements */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl" />
      <div className="absolute top-1/3 -right-32 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-indigo-600/10 rounded-full blur-3xl" />

      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.04)_1px,transparent_0)] bg-[length:24px_24px] opacity-30" />

      <div className="relative w-full max-w-5xl px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <img
            src={Logo}
            alt="Infraconsoft V5"
            className="mx-auto h-20 mb-4 rounded-lg shadow-xl"
          />
          <h1 className="text-4xl md:text-5xl font-bold tracking-wide">
            Infraconsoft <span className="text-blue-400">V5</span>
          </h1>
          <p className="text-gray-400 mt-3 max-w-xl mx-auto">
            A next-generation Construction ERP for project control, inventory,
            payroll, and enterprise operations.
          </p>

          {/* ERP Capability Icons */}
          <div className="flex justify-center gap-6 mt-6 text-gray-400">
            <div className="flex items-center gap-2 text-sm">
              <Building2 className="h-5 w-5 text-blue-400" /> Projects
            </div>
            <div className="flex items-center gap-2 text-sm">
              <HardHat className="h-5 w-5 text-emerald-400" /> Workforce
            </div>
          </div>
        </div>

        {/* Navigation Cards */}
        <div className="grid md:grid-cols-2 gap-10">
          {/* Admin Master */}
          <a
            href="/adminMaster/login"
            className="group relative bg-slate-800/70 backdrop-blur-xl rounded-2xl p-8 shadow-2xl hover:scale-[1.03] transition-all duration-300"
          >
            <div className="absolute inset-0 rounded-2xl border border-transparent group-hover:border-blue-500/60 transition" />
            <Shield className="h-12 w-12 text-blue-400 mb-4" />
            <h2 className="text-2xl font-semibold mb-2">Admin Master</h2>
            <p className="text-gray-400 text-sm">
              Centralized control for masters, configurations, permissions, and
              system governance.
            </p>
          </a>

          {/* Inventory / Payroll Admin */}
          <a
            href="/admin/login"
            className="group relative bg-slate-800/70 backdrop-blur-xl rounded-2xl p-8 shadow-2xl hover:scale-[1.03] transition-all duration-300"
          >
            <div className="absolute inset-0 rounded-2xl border border-transparent group-hover:border-emerald-500/60 transition" />
            <Users className="h-12 w-12 text-emerald-400 mb-4" />
            <h2 className="text-2xl font-semibold mb-2">
              Inventory / Payroll Admin
            </h2>
            <p className="text-gray-400 text-sm">
              Manage materials, payroll, employees, and day-to-day operational
              workflows.
            </p>
          </a>
        </div>

        {/* Footer */}
        <div className="text-center mt-14 text-xs text-gray-500">
          © {new Date().getFullYear()} Infraconsoft V5 · Construction ERP Platform
        </div>
      </div>
    </div>
  );
}
